import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import {
    ModalProvider,
    Modal,
    ModalControl,
    ModalContent,
    ModalHeader,
    ModalBody,
    Overlay,
    CrossIcon,
    Title,
} from '@paygreen/paygreen-ui';

const ModalBlock = ({
    blockWidth,
    children,
    button,
    hasCloseCross,
    modalTitle,
    closeWithAction,
    openingCondition,
    paddingLateral,
    ...rest
}) => {
    const [isOpen, setIsOpen] = useState(openingCondition || false);

    useEffect(() => {
        setIsOpen(openingCondition);
    }, [openingCondition]);

    if (closeWithAction) {
        return (
            <>
                {button &&
                    React.cloneElement(button, {
                        onClick: () => setIsOpen(true),
                    })}

                <Modal isOpen={isOpen} {...rest}>
                    <Overlay gradient="theme" opacityValue={60} />

                    <ModalContent blockWidth={blockWidth}>
                        {modalTitle || hasCloseCross ? (
                            <ModalHeader
                                paddingLateral={paddingLateral}
                                paddingTop="sm"
                            >
                                {modalTitle ? (
                                    <Title textSize="md" colorWab="grey40">
                                        {modalTitle}
                                    </Title>
                                ) : null}

                                {hasCloseCross ? (
                                    <CrossIcon
                                        htmlTag="button"
                                        type="button"
                                        iconSize="md"
                                        colorPallet="wab"
                                    />
                                ) : null}
                            </ModalHeader>
                        ) : null}

                        <ModalBody
                            paddingTop={modalTitle ? 'none' : 'sm'}
                            paddingBottom="xs"
                            paddingLateral={paddingLateral}
                        >
                            {children &&
                                React.cloneElement(children, {
                                    closeWithAction: closeWithAction,
                                    setIsModalOpen: setIsOpen,
                                })}
                        </ModalBody>
                    </ModalContent>
                </Modal>
            </>
        );
    } else {
        return (
            <ModalProvider>
                {button && <ModalControl>{button}</ModalControl>}

                <Modal>
                    <ModalControl>
                        <Overlay gradient="theme" opacityValue={60} />
                    </ModalControl>

                    <ModalContent blockWidth={blockWidth}>
                        {modalTitle || hasCloseCross ? (
                            <ModalHeader
                                paddingLateral={paddingLateral}
                                paddingTop="sm"
                            >
                                {modalTitle ? (
                                    <Title textSize="md" colorWab="grey40">
                                        {modalTitle}
                                    </Title>
                                ) : null}

                                {hasCloseCross ? (
                                    <ModalControl>
                                        <CrossIcon
                                            htmlTag="button"
                                            type="button"
                                            iconSize="md"
                                            colorPallet="wab"
                                        />
                                    </ModalControl>
                                ) : null}
                            </ModalHeader>
                        ) : null}

                        <ModalBody
                            paddingTop={
                                modalTitle || hasCloseCross ? 'none' : 'sm'
                            }
                            paddingBottom="sm"
                            paddingLateral={paddingLateral}
                        >
                            {children}
                        </ModalBody>
                    </ModalContent>
                </Modal>
            </ModalProvider>
        );
    }
};

ModalBlock.propTypes = {
    blockWidth: PropTypes.string,
    button: PropTypes.node,
    modalTitle: PropTypes.string,
    hasCloseCross: PropTypes.bool,
    /**
     * Indicate to parent that the modal need action after close
     */
    closeWithAction: PropTypes.func,
    openingCondition: PropTypes.bool,
    paddingLateral: PropTypes.string,
};

ModalBlock.defaultProps = {
    blockWidth: 'sm',
    hasCloseCross: true,
    paddingLateral: 'sm',
};

export default ModalBlock;
